// Replacing == use isn't worth the risk in this legacy file right now
/* eslint-disable eqeqeq */
// Used in thirdparty-general.js, so export everything globally

// The constants below mirror RFParamDecorator.java. Keep them in sync.

/**
 * main buckets are split by dashes
 */
const B = '-';
/**
 * words within a bucket are joined by underscores
 */
const W = '_';
const TEACHER_ID = `teacher${W}`;
const DONOR_ID = `donor${W}`;
const UNKNOWN = 'unknown';

/**
 * @param anyURLQueryOrHash pass in "" for query if you just want to rebuild an rf param from scratch
 * @param campaign Campaign name
 * @param creatorId Teacher ID to use (useful if this isn't a page where the global teacherId is set
 */
window.getDefaultRFParamValue = function (anyURLQueryOrHash: string, campaign: string, pageSource: string | nullish, creatorId?: number | string): string {
    let rfString = window.getRfParamFromQueryStringOrHash(anyURLQueryOrHash);
    // rebuild from scratch
    if (rfString == null || rfString == '') {
        const rfDate = new Date();
        const rfMonthNum = rfDate.getMonth() + 1;
        const rfMonth = (rfMonthNum < 10 ? '0' : '') + rfMonthNum;
        rfString = `${campaign}${B}dc${B}${rfDate.getFullYear()}${B}${rfMonth}`;

        // add pageName if available
        let trailingCampaign;
        if (pageSource) {
            trailingCampaign = (pageSource.toLowerCase()).replace(/\W+/g, W);
            if (rfString.indexOf(trailingCampaign) === -1) {
                rfString += `${B}${trailingCampaign}`;
            }
        } else if (pageName && rfString.split(B).length <= 4) {
            trailingCampaign = (pageName.toLowerCase()).replace(/\W+/g, W);
            if (rfString.indexOf(trailingCampaign) === -1) {
                rfString += `${B}${trailingCampaign}`;
            }
        }

        if (!creatorId && window.isTeacherUserPage()) {
            creatorId = window.teacherId;
        }

        if (window.isCurrentUser(creatorId) && rfString.indexOf(`${TEACHER_ID}${creatorId}`) === -1) {
            rfString += `${B}${TEACHER_ID}${creatorId}`;
        } else if (window.isNonBlankCookie('userId') && window.userId != null && window.userId != '') {
            rfString += `${B}${DONOR_ID}${window.userId}`;
        } else {
            rfString += `${B}${UNKNOWN}`;
        }
    }

    return rfString;
};

window.getRfParamFromQueryStringOrHash = function (anyURLQueryOrHash: string): string {
    let hash = '';
    let query = anyURLQueryOrHash;
    if (anyURLQueryOrHash.indexOf('#') > -1) {
        query = anyURLQueryOrHash.split('#')[0];
        hash = anyURLQueryOrHash.split('#')[1];
    }
    if (query.indexOf('?') > -1) {
        query = query.split('?')[1];
    }
    // first look for rf param on the query string
    const rfValue = window.getQueryStringParam(query, 'rf') ||
        // then try the hash string
        window.getQueryStringParam(hash, 'rf');

    if (rfValue) {
        const rfString = Array.isArray(rfValue) ? rfValue[0] : rfValue;
        return rfString.replace(/[^a-zA-Z0-9-_]/g, '');
    }
    return '';
};

window.addTeacherChallengeIdParamBasedOnRFParam = function (queryString: string): string {
    const teacherId = window.getRfParamTeacherId(queryString);
    const challengeId = window.getQueryStringParam(queryString, 'challengeid');
    if (!challengeId && teacherId && window.userObj?.userId == teacherId && window.userObj.teacherChallengeId) {
        queryString = window.setQueryStringParam(queryString, 'challengeid', window.userObj.teacherChallengeId);
    }
    return queryString;
};

window.setDefaultRFParamOnQuery = function (query: string, campaign: string, pageSource: string | nullish): string {
    const rfString = window.getDefaultRFParamValue(query, campaign, pageSource);
    return window.addTeacherChallengeIdParamBasedOnRFParam(window.setQueryStringParam(query, 'rf', rfString));
};

window.setDefaultRFParamOnURL = function (fullURL: string, campaign: string, pageSource: string | nullish): string {
    const rfString = window.getDefaultRFParamValue(fullURL, campaign, pageSource);
    return window.addTeacherChallengeIdParamBasedOnRFParam(window.setURLParam(fullURL, 'rf', rfString));
};

window.setRebuiltRFParamOnQuery = function (query: string, campaign: string, pageSource: string | nullish): string {
    const rfString = window.getDefaultRFParamValue('', campaign, pageSource);
    return window.addTeacherChallengeIdParamBasedOnRFParam(window.setQueryStringParam(query, 'rf', rfString));
};

window.setRebuiltRFParamOnURL = function (fullURL: string, campaign: string, pageSource: string | nullish): string {
    const rfString = window.getDefaultRFParamValue('', campaign, pageSource);
    return window.addTeacherChallengeIdParamBasedOnRFParam(window.setURLParam(fullURL, 'rf', rfString));
};

window.getRfParamTeacherId = function (rfParamString?: string): number | null {
    let rfParam: string | null = window.getRfParamFromQueryStringOrHash(rfParamString || location.href);
    if (!rfParam) {
        rfParam = window.readCookie('rfParam');
    }
    if (rfParam != null && rfParam.indexOf(TEACHER_ID) > -1) {
        const rfParamTeacherIdArray = rfParam.split(TEACHER_ID);
        for (let i = 0; i < rfParamTeacherIdArray.length; i++) {
            let segment = rfParamTeacherIdArray[i];
            if (segment.indexOf(B) > -1) {
                segment = segment.split(B)[0];
            }
            const rfParamTeacherId = parseInt(segment);
            if (!isNaN(rfParamTeacherId) && rfParamTeacherId > 0) {
                return rfParamTeacherId;
            }
        }
    }
    return null;
};

window.isTeacherUserPage = function (): boolean {
    return window.isCurrentUser(window.teacherId);
};

/**
 * @param testUserId The ID to test against
 * @return Whether the current user matches the given userId
 */
window.isCurrentUser = function (testUserId: number | string | nullish): boolean {
    return window.userId != null && window.userId != '' && testUserId == window.userId;
};
